var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0C5.59659 0 0 5.59659 0 12.5C0 19.4034 5.59659 25 12.5 25C19.4034 25 25 19.4034 25 12.5C25 5.59659 19.4034 0 12.5 0ZM13.6364 6.81818C13.6364 6.5168 13.5166 6.22776 13.3035 6.01465C13.0904 5.80154 12.8014 5.68182 12.5 5.68182C12.1986 5.68182 11.9096 5.80154 11.6965 6.01465C11.4834 6.22776 11.3636 6.5168 11.3636 6.81818V13.6364C11.3636 13.9377 11.4834 14.2268 11.6965 14.4399C11.9096 14.653 12.1986 14.7727 12.5 14.7727C12.8014 14.7727 13.0904 14.653 13.3035 14.4399C13.5166 14.2268 13.6364 13.9377 13.6364 13.6364V6.81818ZM13.6364 17.6136C13.6364 17.3123 13.5166 17.0232 13.3035 16.8101C13.0904 16.597 12.8014 16.4773 12.5 16.4773C12.1986 16.4773 11.9096 16.597 11.6965 16.8101C11.4834 17.0232 11.3636 17.3123 11.3636 17.6136V18.1818C11.3636 18.4832 11.4834 18.7722 11.6965 18.9853C11.9096 19.1985 12.1986 19.3182 12.5 19.3182C12.8014 19.3182 13.0904 19.1985 13.3035 18.9853C13.5166 18.7722 13.6364 18.4832 13.6364 18.1818V17.6136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWhite);
export default __webpack_public_path__ + "static/media/warningWhite.5e44f825010fff39b25a039e5cb7b066.svg";
export { ForwardRef as ReactComponent };